











































































import Vue from "vue";
import { TableLayout } from "@/layouts";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { eventBus } from "../utils/event";

import Edit from "@/components/PrjRoute/Edit.vue";
import RouteInfo from "@/components/PrjRoute/RouteInfo.vue";

const PrjRouteHeaders: Header[] = [
  { title: "路由名称", key: "" },
  { title: "域名", key: "" },
  { title: "协议", key: "" },
  { title: "密钥", key: "" },
  { title: "创建时间", key: "", width: 180 },
  { title: "操作", key: "", width: 80 }
];
export default Vue.extend({
  name: "PrjRoute",
  components: { TableLayout, Edit, RouteInfo },
  props: { projectId: { type: String } },
  data() {
    return {
      PrjRouteHeaders,
      showTools: true,
      value: "",
      disabled: false
    };
  },
  computed: {
    ...mapState("PrjRoute", [
      "total",
      "hasNext",
      "pageNum",
      "loading",
      "pageSize"
    ]),
    ...mapGetters("PrjRoute", ["tableData"])
  },
  mounted() {
    this.getRoute();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    ...mapActions("PrjRoute", [
      "getData",
      "pageTurn",
      "clear",
      "delete",
      "filterSearch"
    ]),
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    getRoute() {
      this.getData({ url: `/ingress/${this.projectId}` });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.metadata.name);
          break;
      }
    },
    create(data: any) {
      (this.$refs.edit as any)?.show(data);
    },
    del(name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete({
          url: `/ingress/${this.projectId}/${name}`,
          getDataUrl: `/ingress/${this.projectId}`
        }).then(() => {
          this.$message.success("刪除成功");
        });
      });
    },
    showRouteInfo(name: string) {
      this.showTools = false;
      eventBus.$emit("setBeard", {
        name: "路由详情",
        callback: () => {
          this.showTools = true;
          (this.$refs.routeInfo as any).close();
        }
      });
      (this.$refs.routeInfo as any)?.show(name);
    }
  }
});
